import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
    Image,
    Card,
    CardHeading3,
    CardImage,
    Text,
    Link
} from '@blueprint/ui';

const StyledCard = styled(Card)(
    (props) => css`
        display: flex;
        flex-direction: column;
        border-radius: 0;
        padding: 0;
        height: 100%;

        ${props.theme.mq.medium} {
            margin-top: auto;
            border-radius: ${props.theme.spacing['4px']};
        }

        ${CardHeading3} {
            margin: 0 0 ${props.theme.spacing['8px']} 0;
        }

        ${CardImage} {
            margin-top: 0;
            margin-left: 0;
            min-width: 100%;
            height: 100%;
        }
    `
);

const PropertyImage = styled('div')`
    display: block;
    width: 100%;
    height: 11.125rem; /* 178px */
    flex-shrink: 0;
`;

const PropertyDetails = styled('div')(
    (props) => css`
        padding: ${props.theme.spacing['16px']};
    `
);

const TitleWrapper = styled('div')(
    () => css`
        display: flex;
        flex-flow: column wrap;
    `
);

const StyledPropertyPrice = styled(Text)(
    (props) => css`
        margin-bottom: ${props.theme.spacing['8px']};
    `
);

const StyledPropertyTitle = styled(Text)(
    (props) => css`
        margin-bottom: ${props.theme.spacing['4px']};
    `
);

const StyledPropertyAddress = styled(Text)`
    margin-bottom: 0;
`;

const AgentImageWrapper = styled('div')(
    (props) => css`
        padding: ${props.theme.spacing['16px']} 0;
        border-top: solid 1px ${props.theme.colors['graphic-divider']};

        ${props.theme.mq.medium} {
            margin-top: auto;
        }
    `
);

const AgentImage = styled(Image)(
    (props) => css`
        width: auto;
        height: ${props.theme.spacing['32px']};
    `
);

const PropertyDetailsContainer = styled('div')(
    (props) => css`
        display: flex;
        flex-flow: column nowrap;
        height: 100%;
        background: ${props.theme.colors.white};
        margin-top: ${props.theme.spacing['8px']};
        box-shadow: 0 0.25rem 1.5rem rgba(150, 159, 190, 0.2);

        ${props.theme.mq.medium} {
            margin-top: 0;
            box-shadow: none;
        }
    `
);

const PropertyWrapper = styled('div')(
    (props) => css`
        display: none;
        flex-flow: row wrap;
        padding: ${props.theme.spacing['16px']};
        background: ${props.theme.colors['graphic-background-accent-light']};
        margin-bottom: 2rem;

        ${props.theme.mq.medium} {
            display: flex;
        }

        ${props.theme.mq.extraLarge} {
            padding: ${props.theme.spacing['24px']};
        }

        ${Link} {
            display: inline-block;
            width: calc((100% - (${props.theme.spacing['16px']} * 2)) / 3);
            height: auto;
            margin-right: ${props.theme.spacing['16px']};

            ${props.theme.mq.extraLarge} {
                width: calc((100% - (${props.theme.spacing['24px']} * 2)) / 3);
                max-width: 100%;
                margin-right: ${props.theme.spacing['24px']};
            }

            &:last-of-type {
                margin-right: 0;
            }
        }
    `
);

export {
    PropertyWrapper,
    TitleWrapper,
    AgentImage,
    StyledCard,
    PropertyDetails,
    StyledPropertyPrice,
    StyledPropertyTitle,
    StyledPropertyAddress,
    AgentImageWrapper,
    PropertyDetailsContainer,
    PropertyImage
};
